import * as ko from "knockout";

ko.components.register('artist-recommendation-text', {
	viewModel: function (params) {
		var self = this;
		self.artist = ko.observable(params.artist);

		self.content_class = params.content_class ?? '';
		// Honor newlines by default; appended caller CSS can extend or override.
		self.content_style = 'white-space: break-spaces;' + (params.content_style ?? '');

		self.editing = ko.observable(false);
		self.new_text = ko.observable('');

		self.save = () => {
			console.log('save', self.artist().artist_uuid(), self.new_text());

			return $.ajax({

				url: scvm.web_host + '/api/admin/artist/recommendation-text',
				type: 'POST',
				data: ko.toJSON({
					artist_uuid: self.artist().artist_uuid(),
					recommendation_text: self.new_text()
				}),
				processData: false,

				contentType: "application/json; charset=utf-8",

				success: (data) => {
					if (data.success) {
						self.artist().recommendation_text(data.recommendation_text);
						self.editing(false);
						notyf.success("Saved!");
					}
					else {
						notyf.error(data.message);
						self.editing(true);
					}

				},
				error: function (jqXHR, errorStatus, thrownError) {
					var response = jQuery.parseJSON(jqXHR.responseText);
					notyf.error(response.message);
				}
			});
		}

		self.cancel = () => {
			console.log('cancel', self.artist().artist_uuid(), self.new_text());
			self.editing(false);
		}
	},
	template:
		`
		<div class="d-flex justify-content-between align-items-start" data-bind="if: !editing()">
			<span data-bind="text: artist().recommendation_text, css: content_class, attr: { style: content_style }"></span>
			<button class="btn btn-sm btn-link mdi mdi-18px mdi-notebook-edit p-0 lh-1" data-bind="click: () => { new_text(artist().recommendation_text()); editing(true) }"></button>
		</div>
		<div data-bind="if: editing()">
			<textarea class="w-100" style="min-height: 120px" data-bind="value: new_text"></textarea>
			<div class="d-flex gap-1">
				<button class="btn btn-sm btn-danger w-100" data-bind="click: cancel">Cancel</button>
				<button class="btn btn-sm btn-primary w-100" data-bind="click: save">Save</button>
			</div>
		</div>
		`
});